import { Form as FormComponent } from './form';
import { FormContainer } from './parts/container';
import { FormSection } from './parts/section';

export const Form = Object.assign(FormComponent, {
  Container: FormContainer,
  Section: FormSection
});
